<template>
  <h1>SummaryReport</h1>

  <dev-panel>
    <div class="mt-2">
      <input-button state="dev" @click="loadFromAnswers">
        Submit answers to backend and generate
        report
      </input-button>
    </div>
    <div class="mt-2">
      <select v-model="considerationLevel" class="form-control">
        <option value="">
          (none)
        </option>
        <option :value="considerationLevels[0]">
          Green
        </option>
        <option :value="considerationLevels[1]">
          Yellow
        </option>
        <option :value="considerationLevels[2]">
          Red
        </option>
      </select>
    </div>
    <div class="mt-2">
      <select v-model="origin" class="form-control">
        <option value="standalone">
          Standalone
        </option>
        <option value="fullReport">
          FullReport
        </option>
      </select>
    </div>
    <div class="mt-2">
      <input-button-toggle v-model="highRiskIndicator">
        High risk indicator
        ({{ highRiskIndicator ? 'On' : 'Off' }})
      </input-button-toggle>
    </div>
    <div class="mt-2">
      <input-button-toggle v-model="bddIndicator">
        BDD indicator
        ({{ bddIndicator ? 'On' : 'Off' }})
      </input-button-toggle>
    </div>
    <div class="mt-2">
      <input-button-toggle v-model="impulsivityIndicator">
        Impulsivity indicator
        ({{ impulsivityIndicator ? 'On' : 'Off' }})
      </input-button-toggle>
    </div>
  </dev-panel>

  <div v-if="loading" class="mt-4">
    Loading..
  </div>
  <div v-else class="mt-4">
    <summary-report
      :consideration-level="considerationLevel"
      :high-risk-indicator="highRiskIndicator"
      :bdd-indicator="bddIndicator"
      :impulsivity-indicator="impulsivityIndicator"
      :advices="advices"
      :origin="origin"
    />
  </div>
</template>

<script>
import SummaryReport from '@/components/Report/SummaryReport';
import {
  CONSIDERATION_LEVEL_GREEN,
  CONSIDERATION_LEVEL_RED,
  CONSIDERATION_LEVEL_YELLOW,
} from '@/enum/ConsiderationLevel';
import InputButton from '@/components/Inputs/common/InputButton/InputButton';
import InputButtonToggle from '@/components/Inputs/common/InputButton/InputButtonToggle';
import DevComponentContainer from '@/components/DevComponent/DevComponentContainer';
import DevPanel from '@/components/DevComponent/DevPanel';

export default {
  name: 'SummaryReportDev',
  components: {
    DevPanel, InputButton, InputButtonToggle, SummaryReport,
  },
  extends: DevComponentContainer,
  data() {
    return {
      loading: false,

      considerationLevels: [CONSIDERATION_LEVEL_GREEN, CONSIDERATION_LEVEL_YELLOW, CONSIDERATION_LEVEL_RED],

      considerationLevel: CONSIDERATION_LEVEL_GREEN,
      highRiskIndicator: false,
      bddIndicator: false,
      impulsivityIndicator: false,

      origin: 'standalone',

      advices: [
        {
          id: 'fake1',
          headline: 'Lorem ipsum',
          advice: 'Your answer about not being concerned about the risk of a new regret seems to indicate that you would benefit from reconsidering the risks involved in the cosmetic surgery/treatment you are now considering. Prefferably in dialogue with other people around you. Make sure you weigh up the expected benefits against the potential risks.',
        },
        {
          id: 'fake2',
          headline: 'Lorem ipsum',
          advice: 'Your answer about number of previous cosmetic surgeries/treatments indicate that you could benefit from reflecting on how your previous cosmetic interventions have impacted on your general well-being. And use such reflection actively as guide in relation to the cosmetic surgery/treatment you are now considering.',
        },
        {
          id: 'fake3',
          headline: 'Lorem ipsum',
          advice: 'Considering how unhappy you have been with the previous treatments, you would benefit from re-evaluating the cosmetic surgery/treatment you are now considering. This should include discussing with other people around you, and read more about the pros can cons of the procedure. Furthermore, put some serious thought into whether dissatisfaction with certain parts of you your body has now moved from one area to another (e.g.: from skin to nose)',
        },
        {
          id: 'fake4',
          headline: 'Lorem ipsum',
          advice: 'Since you have experienced extreme regrets related to previous cosmetic surgery/treatment, why are you now considering more cosmetic surgery/treatment? Ask this question not only to yourself, but also to people around you. Furthermore, put some serious thoughts into the likelihood of experiencing extreme regret yet again.',
        },
      ],
    };
  },
  methods: {
    loadFromAnswers() {
      this.loading = true;

      this.considerationLevel = '';
      this.highRiskIndicator = false;
      this.bddIndicator = false;
      this.impulsivityIndicator = false;
      this.advices = [];

      this.$apiClient.survey.getRandomAnswers('main').then((answers) => {
        this.$apiClient.survey.submitAnswers('main', answers, true).then((submissionResult) => {
          this.considerationLevel = submissionResult.considerationLevel;
          this.highRiskIndicator = submissionResult.indicatorsActive.highRisk;
          this.bddIndicator = submissionResult.indicatorsActive.bdd;
          this.impulsivityIndicator = submissionResult.indicatorsActive.impulsivity;
          this.advices = submissionResult.advice;

          this.loading = false;
        });
      });
    },
  },
};
</script>
